import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";

const rootElement = document.getElementById("root");
window.addEventListener("error", (e) => {
    alert("App error: " + (e.error?.message || e.message));
});

window.addEventListener("unhandledrejection", (e) => {
    alert("Unhandled rejection: " + (e.reason?.message || e.reason));
});

if (rootElement) {
    ReactDOM.render(
        <React.StrictMode>
            <Router>
                    <App />

            </Router>
        </React.StrictMode>,
        rootElement
    );
} else {
    console.error('Failed to find the root element');
}